const ONLINE_INT = 10 * 1000;
export const config =  {
  API_URL : 'https://3y4fhv1td1.execute-api.ap-southeast-1.amazonaws.com/prod/',
  'x-api-key': 'thZERYhJpV86X5JeVaNO9aYCF6TNmNxC6QMQLqhu',
  firebase: {
    apiKey: "AIzaSyDa5mO3Y9RkuFsIgc-oBqvas84BVuW9Bl8",
    authDomain: "fir-chat-8ba24.firebaseapp.com",
    databaseURL: "https://fir-chat-8ba24.firebaseio.com",
    projectId: "fir-chat-8ba24",
    storageBucket: "fir-chat-8ba24.appspot.com",
    messagingSenderId: "215061227613",
    appId: "1:215061227613:web:b11c312752f70e54a385b4",
    measurementId: "G-ETXYDFJMT4"
  },
  KEEP_ALIVE_INTERVAL: ONLINE_INT,
  ONLINE_TIMEOUT: ONLINE_INT + 1000,
  ONLINE_UPDATE_INTERVAL: 4000,
  SHOW_FEEDBACK: false
}

export const FrontendRoutes = {
  COUNTDOWN: "/",
  AFTER_EVENT_MESSAGE: "/coming-soon",
  USERNAME: "/username",
  HOME: "/home",
  PROGRAMME: "/programme",
  BALLROOM: (type, startFrom) => `/ballroom${type ? '?type=' + type : ''}${startFrom ? '&startFrom=' + startFrom : ''}`,
  CONVERSATION: "/conversation",
  PHOTO_BOOTH: "/photobooth",
  SOCIAL_WALL: "/socialwall",
  FEEDBACK: "/feedback",
  UNAUTHORIZED: "/unauthorized",
  FAQ: "/faq",
  LOGOUT: "/logout",
  SOCIAL_WALL_MODERATION: '/admin/socialwall',
  QA_MODERATION: '/admin/qa',
  REPORTS: '/admin/reports'
}

export const ItemTypes = {
  PHOTO: 'PHOTO',
  MESSAGE: 'MESSAGE'
}

export const ItemStatuses = {
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
}